import React from 'react';
import Chrome from "../../resources/images/browsers/chrome_256x256.png";
import Edge from "../../resources/images/browsers/edge_256x256.png";
import Firefox from "../../resources/images/browsers/firefox_256x256.png";
import Opera from "../../resources/images/browsers/opera_256x256.png";
import Safari from "../../resources/images/browsers/safari_256x256.png";
import "./_check-browser.scss";
import { useTranslation } from 'react-i18next';

export default function CheckBrowser() {

    const { t } = useTranslation();

    return (
        <div className="check-browser">
            <div className="check-browser-icon">
                <i className="fa-thin fa-browser" />
                <i className="fa-solid fa-ban fa-flip-horizontal" />
            </div>
            <h4>{t("oldBrowserDetected")}</h4>
            <h5>{t("oldBrowserDetectedText")}</h5>
            <div className="check-browser-images">
                <a href="https://www.google.com/chrome/">
                    <img src={Chrome} alt="Chrome" />
                </a>
                <a href="https://www.mozilla.org/firefox/">
                    <img src={Firefox} alt="Firefox" />
                </a>
                <a href="https://www.microsoft.com/edge/download">
                    <img src={Edge} alt="Edge" />
                </a>
                <a href="https://www.opera.com/">
                    <img src={Opera} alt="Opera" />
                </a>
                <a href="https://support.apple.com/HT204416">
                    <img src={Safari} alt="Safari" />
                </a>
            </div>
        </div>
    )
}
